import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input, Typography, Link, Paper, LinearProgress } from '@material-ui/core';
import { asyncFetch } from '../../helperFunctions';
import { createPinDialog, setSnackbar, signedTechnicians } from '../redux';

const paperStyle = { margin: '15px', padding: '15px' };
const buttonStyle = { marginLeft: '15px' };
const progressStyle = { marginTop: '20px' };

export default props => {
  const { technician, setOpen } = props;
  const dispatch = useDispatch();
  const data = useSelector(state => state.tasks.signedTechnicians);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (technician?.isLogedUser) {
      dispatch(createPinDialog(!technician?.isPinCreated));
    }
  }, [dispatch, technician]);

  const technicianIsSegned = data.technicians.find(x => x.userId === technician.userId)?.isSigned;

  const header = {
    headers: new Headers({
      'Content-Type': 'application/json',
      accept: '*',
      authorization: `OSS ${localStorage.getItem('OSS_Token')}`,
    }),
  };
  const handleClick = e => {
    e.preventDefault();
    setOpen(true);
  };

  return (
    !technicianIsSegned && (
      <Paper style={paperStyle}>
        <Typography>{technician.names}</Typography>
        <Typography>
          Декларирам, че отворих
          <Link onClick={handleClick}>Инструкциите</Link>, запознах се с тях и ще спазвам
          Инструкциите и Правилата за работа, касаещи длъжността ми.
        </Typography>
        <Input
          size="small"
          disabled={loading}
          placeholder="Въведете ПИН"
          type="password"
          margin="none"
          onChange={y => setPassword(y.target.value)}
        />
        <Button
          style={buttonStyle}
          disabled={password.length === 0 || loading}
          onClick={async () => {
            setLoading(true);
            const response = await asyncFetch(
              `${process.env.REACT_APP_TECHNICIANS_API}/DigitalsSignatures/signing`,
              {
                method: 'POST',
                mode: 'cors',
                referrerPolicy: 'strict-origin-when-cross-origin',
                body: JSON.stringify({
                  userName: technician.userName,
                  userId: technician.userId,
                  pin: password,
                }),
              },
              {
                'Content-Type': 'application/json',
              },
              undefined,
              dispatch
            );

            if (response) {
              if (response.isSuccess) {
                const t = data.technicians.find(x => x.userId === technician.userId);
                t.isSigned = true;

                const copy = data.technicians.filter(x => x.userId !== t.userId);

                copy.push(t);

                dispatch(
                  signedTechnicians({
                    technicians: copy,
                    show: copy.every(x => x.isSigned),
                    refresh: true,
                  })
                );
              }
            }
            if (response && response.errorMessage) {
              dispatch(setSnackbar({ open: true, message: response.errorMessage }));
            }
            setLoading(false);
          }}
          variant="contained"
        >
          Подписване
        </Button>
        {technician.pdfPath && (
          <Button
            style={buttonStyle}
            variant="contained"
            onClick={async () => {
              const response = await fetch(
                `${process.env.REACT_APP_TECHNICIANS_API}/DigitalsSignatures/download-pdf`,
                {
                  ...header,
                  method: 'POST',
                  body: JSON.stringify({
                    filePath: technician.pdfPath,
                  }),
                }
              );

              const file = await response.blob();
              const fileUrl = window.URL.createObjectURL(file);

              window.open(fileUrl);
            }}
          >
            Виж
          </Button>
        )}
        {loading && <LinearProgress style={progressStyle} />}
      </Paper>
    )
  );
};
